module.exports = __webpack_public_path__ + "static/media/5.9f2135ca.jpg";